import React from 'react';
import PropTypes from 'prop-types';
import {
  Redirect, Route, Switch, withRouter, useLanguage,
} from '@ipc/ipc-core';

// import Home from '../common/Home';
import NotFound from '../common/NotFound';
import PrivateRoute from '../common/PrivateRoute';
import Login from '../common/Login';
import CreatePreSettlement from '../../pages/CreatePreSettlement';
import PreSettlementList from '../../pages/PreSettlementList';
import RedirectTo from '../custom/RedirectTo';
import RecordsList from '../../pages/RecordsList';
import ReceptaclesList from '../../pages/ReceptaclesList';
import DefaultAla from '../../pages/DefaultAla';
import CreateAlaLevel from '../../pages/CreateAlaLevel';
import AlaLevelAgreements from '../../pages/AlaLevelAgreements';
import Performance from '../../pages/Performance';
import MasterData from '../../pages/MasterData';
import MasterDataResult from '../../pages/MasterDataResult';
import ReceptacleSearchCriteria from '../../pages/ReceptacleSearchCriteria';
import InvoiceInformationSearchCriteria from '../../pages/InvoiceInformationSearchCriteria';
import InvoiceInformationList from '../../pages/InvoiceInformationList';

export const AppContent = () => {
  const [, language] = useLanguage();
  return (
    <div className="appContent">
      <Switch>
        <Route exact path={language('/login')} component={Login} />
        <Route exact path="/" render={() => <Redirect to="/home" />} />
        <Route exact path={language('/')} render={() => <Redirect to="/home" />} />
        <PrivateRoute exact path={language('/pre-settlement/create')} component={CreatePreSettlement} />
        <PrivateRoute exact path={language('/pre-settlement/:id/copy')} component={CreatePreSettlement} />
        <PrivateRoute exact path={language('/pre-settlement/list')} component={PreSettlementList} />
        <PrivateRoute exact path={language('/records/list')} component={RecordsList} />
        <PrivateRoute exact path={language('/receptacles/list/search')} component={ReceptacleSearchCriteria} />
        <PrivateRoute exact path={language('/receptacles/list/:filter/search')} component={ReceptacleSearchCriteria} />
        <PrivateRoute exact path={language('/receptacles/list')} component={ReceptaclesList} />
        <PrivateRoute exact path={language('/receptacles/list/:filter')} component={ReceptaclesList} />
        <PrivateRoute exact path={language('/configuration/default')} component={DefaultAla} />
        <PrivateRoute exact path={language('/configuration/create')} component={CreateAlaLevel} />
        <PrivateRoute exact path={language('/configuration/edit/:id')} component={CreateAlaLevel} />
        <PrivateRoute exact path={language('/configuration/copy/:id')} component={CreateAlaLevel} />
        <PrivateRoute exact path={language('/configuration/agreements')} component={AlaLevelAgreements} />
        <PrivateRoute exact path={language('/master-data')} component={MasterData} />
        <PrivateRoute exact path={language('/master-data/:id')} component={MasterDataResult} />
        <PrivateRoute exact path={language('/performance')} component={Performance} />
        <PrivateRoute exact path={language('/invoice/search')} component={InvoiceInformationSearchCriteria} />
        <PrivateRoute exact path={language('/invoice/list')} component={InvoiceInformationList} />
        <PrivateRoute exact path={language('/home')} component={PreSettlementList} />
        <PrivateRoute exact path={language('/redirect')} component={RedirectTo} redirectBack />
        <Route exact path={language('/login')} component={Login} />
        <Route component={NotFound} />
      </Switch>
    </div>
  );
};

AppContent.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }),
};

export default withRouter(AppContent);
